<template>
    <div>
        <!-- If It has sublabels show as its own row without the parent label-->
        <div v-if='hasSublabels'>
            <div v-for='entries in object[property.column].value'>
                <div class='row' v-for='entry in arrayify(entries)' v-if='entry.value !== ""'>
                    <div class='col-md-2 hidden-print'></div>
                    <div class='col-md-3'><strong>{{entry.label}}</strong></div>
                    <div class='col-md-7 honor-newline'>
                        <div v-for='value in arrayify(entry.value)'>
                            <a v-if='link' :href="generateLink(paramByLink(value))" v-html='value' :itemprop="metatag"></a>
                            <span v-else :itemprop="metatag" v-html='value'></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- If no sublabels display label and any nested property -->
        <div v-else>
            <div class='row'>
                <div class='col-md-2 hidden-print'></div>
                <div class='col-md-3'><strong>{{property.label}}</strong></div>
                <div class='col-md-7'>
                    <div v-if='isNested'>
                        <div v-for='entries in object[property.column].value'>
                            <div v-for='entry in arrayify(entries)' v-if='entry !== ""' class='honor-newline'>
                                <a v-if='link' :href="generateLink(paramByLink(value))" v-html='entry' :itemprop="metatag"></a>
                                <span v-else :itemprop="metatag" v-html='entry'></span>
                            </div>
                        </div>
                    </div>
                    <div v-else class='honor-newline'>
                        <a v-if='link' :href="generateLink(paramByLink(object[property.column].value))" v-html='object[property.column].value' :itemprop="metatag"></a>
                        <span v-else :itemprop="metatag" v-html='object[property.column].value'></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import manageProperties from './../../../mixins/manageProperties.js'
    import ViewRelated from './../../../mixins/viewRelated.js'

    export default {
        props: ['object', 'property', 'link', 'metatag'],
        mixins: [manageProperties, ViewRelated],
        methods: {
            paramByLink: function (value) {
                var obj = {}
                obj[this.link] = value
                return obj
            },
        },
        computed: {
            hasSublabels: function () {
                if (!this.isNested) {
                    return false
                }

                // Get entries
                var entries = this.object[this.property.column].value

                // If the first entry doesn't have a label property there are no sublabels
                return (typeof this.arrayify(entries)[0][0].label !== "undefined")
            },

            isNested: function () {
                return Array.isArray(this.object[this.property.column].value)
            }
        },
    }
</script>
